export const initialState = {
    resumeJobStatus: "init",
    isSuccess: false,
    errorCode: '1',
    selectedUtils: '',
    selectedScope: '',
    selectedCities: [],
    adsCareersData: [],
    filterJobData:["SHOW_ALL"],
    locationsRegion: [],
    locationCareersData: [],
    utilsCareersData:[],
    careerScopeList: ["משרה מלאה", "משרה חלקית", "משמרות", "משרה ללא ניסיון", "משרת סטודנט", "משרת הורים"],
    cities: "",
     pageCareersData: {
      mainTitle : "",
      subTitle : "",
      jobTitle : "",
    },
    submitData: {
        name: "",
        title:""
    },
    buttonData: {
        buttonSuccesUrl: '',
        buttonSuccesText: '',
        buttonFailedUrl: '',
        buttonFailedText: ''
    },

};

export  const setCareerScope = {
    0: "משרה מלאה",
    1: "משרה חלקית",
    2: "משמרות",
    3: "משרה ללא ניסיון",
    4: "משרת סטודנט",
    5: "משרת הורים"

}

